/**
 * /devhub/intake — Prompt intake (operator). Surface Layer (/01). REQ-001.91 DevHub UI rebuild · Phase 3.
 * Live operator panel (DevHubPromptIntakePanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubPromptIntakePanel } from '../features/control-plane/DevHubPromptIntakePanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/intake')({ component: IntakePage });

function IntakePage() {
  return (
    <DevHubPanelPage
      title="Prompt intake"
      subtitle="Composer with deterministic risk classification and dispatch."
      status={{ label: 'live', live: true }}
    >
      <DevHubPromptIntakePanel />
    </DevHubPanelPage>
  );
}
